<template>
  <div v-if="value === modelValue">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useTabsContext } from "./UITabs.vue";

defineProps<{ value: string }>();
const { modelValue } = useTabsContext();
</script>
